import $ from 'jquery';

// constants for SINEQUE search
const MESSAGE_ERROR_FIRST_LINE = "La recherche sur le site est momentanément indisponible.",
    MESSAGE_ERROR_SECOND_LINE = "Nous vous invitons à renouveller votre recherche ultérieurement.",
    CLASS_SEARCH_OUTPUT = "dcw_results_output",
    LABEL_RESULTAT = " r\u00e9sultat",
    LABEL_RESULTATS = " r\u00e9sultats";


export default class Sinequa {

    constructor($contentZone, keyword) {	
	
        this.container = $contentZone;
		this.itemslist = $('<ul></ul>');
		
		this.keyword=keyword;
		

		var origin=""; 
	    if (this.keyword == null || this.keyword == undefined || this.keyword == "") {
			this.keyword = "";
		}
		else {
			var keywordlength = this.keyword.length-1;
 			origin = this.keyword.substr(keywordlength,1);
			this.keyword = this.keyword.substr(0, keywordlength );
		}	
		
		this.keywordTms = this.formatTms(this.keyword);
		
		this.searchengin="barre-page-de-recherche";	
		if (origin == "b") {
			this.searchengin="barre-de-recherche";
		}	
		else if (origin == "p") {
			this.searchengin="page-de-recherche";
		}	
		
       // Keep global config
        this.nbResultsToDisplay = window.cmsGlobals.sinequaConfig.sinequaResultsToDisplay;
		// !!! Only for tests vf-kli !!!
		//this.nbResultsToDisplay=2;
		//if (origin == "0") this.nbResultsToDisplay=0;
 		
        this.nbSponsorizedLinks = window.cmsGlobals.sinequaConfig.numSpLinks;
        this.numItem = window.cmsGlobals.sinequaConfig.numItem;

        this.results = null;
        this.links = null;
        this.nbResultsNatural = null;
        this.nbResultTotal = null;
        this.indexResult = 0;
		
		
         // keep possibility to switch xsearch / xrest API
        this.methodXsearch = window.cmsGlobals.sinequaConfig.methodXsearch;
        this.secureContext = false;
        if (tc_vars["user_is_logged"] === true) {
            this.secureContext = true;
        }
        // Keep right Url
        if (this.methodXsearch) {
            if (this.secureContext) {
                this.url = window.cmsGlobals.sinequaConfig.sinequaResultsXsearchSecure;
            } else {
                this.url = window.cmsGlobals.sinequaConfig.sinequaResultsXsearch;
            }
        } else {
            if (this.secureContext) {
                this.url = window.cmsGlobals.sinequaConfig.sinequaResultsSecure;
            } else {
                this.url = window.cmsGlobals.sinequaConfig.sinequaResults;
            }
        }

    }
	
	// tcod 2741
	formatTms(inputText) {
		if (inputText) {
			return inputText.replace(/[\s+]/g, '-').replace(/[éèê]/g,"e").replace(/[\u2018\u2019\u0027]/g, "-").replace(/à/g,"a").toLowerCase();
		}	
		return "";
	}
	
	displayMessage(pmessage, pclass) {
		if ($("#id_results_output").length) {
			$("#id_results_output").empty();
			$("#id_results_output").removeClass().addClass(pclass).html(pmessage);
		}
		// For pages with old html :
		else {
			this.container.append("<p class=\""+pclass+"\" role=\"status\">"+pmessage+"</p>");
		}
    }


    // BUILD
    manageSearchFail() {
		this.displayMessage(MESSAGE_ERROR_FIRST_LINE+"<br/>"+MESSAGE_ERROR_SECOND_LINE, CLASS_SEARCH_OUTPUT);
		
        /*var p = $('<p role="status"></p>').attr("class", CLASS_SEARCH_OUTPUT);
        p.append(document.createTextNode(MESSAGE_ERROR_FIRST_LINE));
        p.append(document.createElement("br"));
        p.append(document.createTextNode(MESSAGE_ERROR_SECOND_LINE));
        this.container.append(p);*/
    }

    buildSearchParagraph(infoToDisplay) {
	
		// tcod 2741 track on paragraphe
        var divWrapper = $('<li></li>').attr("class","dcw_results_wrapper");
		
        var h2 = $('<h2></h2>');
		if (infoToDisplay.hasOwnProperty('aria-live'))
			h2.attr("aria-live", infoToDisplay['aria-live']);

		var alink = $('<a></a>').attr("class","dcw_results_link").attr("href",infoToDisplay['currentUrl']);
		if (infoToDisplay.hasOwnProperty('bddfTms'))
			alink.attr("onclick",infoToDisplay['bddfTms']);
		alink.append($(infoToDisplay["currentTitle"]));
        h2.attr("class","dcw_title").append(alink);
        divWrapper.append(h2);
        divWrapper.append($('<p>' + infoToDisplay["currentText"] + '</p>').attr("class", "dcw_results_desc"));
		var alink = $('<a></a>').attr("class","dcw_results_hypertexte").attr("href",infoToDisplay['currentUrl']);
		if (infoToDisplay.hasOwnProperty('bddfTms'))
			alink.attr("onclick",infoToDisplay['bddfTms']);
		
		divWrapper.append(alink.append(document.createTextNode(infoToDisplay['currentUrl'].replace(window.location.origin,""))));

        return divWrapper;
    }

    // Check if the nb of item is less than the nb of results configurated and then iterate
    displayResults() {
        var resultsToDisplay  = this.nbResultsNatural > this.nbResultsToDisplay ? this.nbResultsToDisplay : this.nbResultsNatural;
        this.indexResult = resultsToDisplay;

        for (var i =0; i < this.indexResult ; i++) {
            var currentResponse = this.results[i];
            var infoToDisplay = this.prepareInfoToDisplay(currentResponse);
            this.itemslist.append(this.buildSearchParagraph(infoToDisplay));
        }
    }

    // Check if the nb of item is less than the nb of results configurated and then iterate
    displaySponsorizedLinks() {
        var nbLinks = this.links.length;
        for (var i =0; i < nbLinks ; i++) {
            var currentLink = this.links[i];
            var infoToDisplay = [];

            if (!currentLink.Summary)
                return;

            // get current Elements
            // prevent % encoding issues (URI malformed)
            var currentText = currentLink.Summary;
            infoToDisplay['currentText'] = currentText;
            infoToDisplay['currentTitle'] = currentLink.Title.replace("<b>","").replace("</b>","").bold();
            infoToDisplay['currentUrl'] = currentLink.Url;

            this.itemslist.append(this.buildSearchParagraph(infoToDisplay));
        }
    }

    prepareInfoToDisplay(currentResponse) {
        var infoToDisplay = [];
        var currentText, currentUrl, currentTitle = "";

        // get current Elements
        // prevent % encoding issues (URI malformed)
        if (this.methodXsearch) {

            if( (!currentResponse.hasOwnProperty('HtmlSummary'))
                || (!currentResponse.hasOwnProperty('Url1'))
                || (!currentResponse.hasOwnProperty('Title'))){
                return ;
            }

            currentText = currentResponse.HtmlSummary;
            currentUrl = currentResponse.Url1;
            currentTitle = currentResponse.Title;

        } else {

            if( (!currentResponse.hasOwnProperty('smallsummaryhtml'))
                || (!currentResponse.hasOwnProperty('resulturl'))
                || (!currentResponse.hasOwnProperty('title'))){
                return ;
            }
            currentText = currentResponse.smallsummaryhtml;
            currentUrl = currentResponse.resulturl;
            currentTitle = currentResponse.title;
			
			// 2741 Clic sur l'un des résultats
			// Propriété infoToDisplay['bddfTms']
			var search_engine_result_page="1"; // no page management otherwise retrieve from response
			var bddfTms = "bddfTms.trackEvent(this,'internal_search_result_click',{"+
				"search_engine_name:'"+ this.searchengin+"',"+
				"search_engine_keyword:'"+ this.keywordTms+"',"+
				"search_engine_result_number:'"+ this.nbResultsNatural.toString()+"',"+
				"search_engine_result_page:'"+ search_engine_result_page+"',"+
				"search_engine_click_rank:'"+ (currentResponse.docrank+1).toString()+"',"+
				"search_engine_click_title:'"+ this.formatTms(currentTitle)+"',"+
				"search_engine_click_uri:'"+ this.formatTms(currentUrl)+"'})";
	        infoToDisplay['bddfTms'] = bddfTms;
        }

        infoToDisplay['currentText'] = currentText;
        infoToDisplay['currentTitle'] = currentTitle.replace("<b>","").replace("</b>","").bold();
        infoToDisplay['currentUrl'] = currentUrl;

        return infoToDisplay;
    }
    
    //  Manage Btn to display more results
    displayMoreResults() {
        var _self = this;
        var isLastIteration = false;
        var lastIndex;
		// 2741
        var link = $('<a></a>').attr("class", "dcw_btn dcw_btn--ghost-dark dcw_results_more").attr("onclick","bddfTms.trackEvent(this, 'click', {event_name:'resultats-de-recherche::clic-sur-voir-plus-de-resultats'});").attr("tabindex","0").attr("role","button").attr("aria-label","Voir plus de résultats (Chargement ci-dessous)").append(document.createTextNode("Voir plus de r\u00e9sultats"));

        link.click(function () {
					
            link.remove();

            if (_self.indexResult + _self.nbResultsToDisplay > _self.nbResultTotal) {
                isLastIteration = true;
                lastIndex = _self.nbResultTotal;
            } else {
                lastIndex = _self.indexResult  + _self.nbResultsToDisplay;
            }

            for (var i = _self.indexResult ; i < lastIndex; i++) {
                var currentResponse = _self.results[i];
                var infoToDisplay = _self.prepareInfoToDisplay(currentResponse);
				//infoToDisplay['aria-live'] = "polite";

                _self.itemslist.append(_self.buildSearchParagraph(infoToDisplay));
            }

            _self.indexResult  = lastIndex;
            if (!isLastIteration)
                _self.displayMoreResults();
        });

        _self.container.append(link);
    }

    // BUILD DOM AFTER AJAX CALL
    buildSearchResults() {
        var _self = this;
        if (this.results == null) {
            this.manageSearchFail();
        } else {
            if (this.nbResultTotal == null) {
                this.nbResultTotal = 0;
            }

            // display number of results
            var responseWord = this.nbResultTotal <= 1 ? LABEL_RESULTAT : LABEL_RESULTATS;
			this.displayMessage(this.nbResultTotal + responseWord + " sur le site", "dcw_results_output");

            /*var p = $('<p role="status"></p>')
                .attr("class","dcw_results_output")
                .append(document.createTextNode(this.nbResultTotal + responseWord + " sur le site"));
            this.container.append(p);*/

			// Create List
			var nitems = 0;

			// Sponsored Links
            if (this.links != null) {
                _self.itemslist.append(this.displaySponsorizedLinks());
				nitems = this.links.length;
            }
			
			// Search results
            _self.itemslist.append(this.displayResults());
			nitems += this.results.length;

			if (nitems >0)
				_self.container.append(_self.itemslist);
			
			// Display more
            if (this.nbResultTotal > this.nbResultsToDisplay) {
                this.displayMoreResults();
            }
        }
    }


	callXAPIDone(response, calltype) {
		

	}
	
	callXAPIFail() {
		
		// tcod 2741 - chargement de la page - fail
		bddfTms.trackEvent(
			this,
			'internal_search_result_display', { 
				search_engine_name : this.searchengin,
				search_engine_keyword : this.keywordTms,
				search_engine_result_number : '0',
				search_engine_result_page : ''
			}
		);
		
        window.EventBusCMS.dispatchEvent('buildSearch', {isReady : 'search'});
	}
	
    callXsearchAPI() {
        var _self = this;
        var settings = {
            "method": "POST",
            "async": true,
            "crossDomain": true,
            "url": _self.url,
            "headers": {
                "Content-Type": "application/x-www-form-urlencoded",
                "Cache-Control": "no-cache"
            },
            "data": {
                "text": _self.keyword,
                "questionlanguage": "fr",
                "type": "json",
                "skipCount": _self.numItem
            }
        }

        $.ajax(settings)
            .done(function (response) {
               if (typeof response.Documents !== "undefined") {
                    _self.results = response.Documents;
                    _self.nbResultsNatural = response.DocumentCount;
					// tcod 2741 - chargement de la page
					var pcurrentPage = response.CurrentPage;
					var currentPage = pcurrentPage.toString();
					if (currentPage=='0') 
						currentPage='';
					bddfTms.trackEvent(
						this,
						'internal_search_result_display', { 
							search_engine_name : _self.searchengin,
							search_engine_keyword : _self.keywordTms,
							search_engine_result_number : _self.nbResultsNatural.toString(),
							search_engine_result_page : currentPage
						}
					);
                }

                if (typeof response.Links !== "undefined") {
                    _self.links = response.Links;
                    _self.nbResultTotal = _self.nbResultsNatural + _self.links.length;
                }

                window.EventBusCMS.dispatchEvent('buildSearch', {isReady : 'search'});
				
            })
            .fail(function () {
				// tcod 2741 - chargement de la page - fail
				bddfTms.trackEvent(
					this,
					'internal_search_result_display', { 
						search_engine_name : _self.searchengin,
						search_engine_keyword : _self.keywordTms,
						search_engine_result_number : '0',
						search_engine_result_page : ''
					}
				);
			
				window.EventBusCMS.dispatchEvent('buildSearch', {isReady : 'search'});
            });
    }
	
    callXrestAPI() {
		
        var _self = this;
        var settings = {
            "method": "GET",
            "async": true,
            "crossDomain": true,
            "url": _self.url,
            "headers": {
                "Cache-Control": "no-cache"
            },
            "data": {
                "query.text" : _self.keyword,
                "query.questionlanguage" : "fr",
                "method": "search.profile",
                "responsetype": "Searchresult"
            }
        }

        $.ajax(settings)
            .done(function(response) {				
				//_self.callXAPIDone(response, "rest");
                if (typeof response.Result !== "undefined") {
                    if (typeof response.Result.Docs !== "undefined") {
                        _self.results = response.Result.Docs;
                        _self.nbResultsNatural = response.DocumentCount;
						
						// tcod 2741 - chargement de la page
						var pcurrentPage = response.CurrentPage;
						var currentPage = pcurrentPage.toString();
						if (currentPage=='0') 
							currentPage='';
						bddfTms.trackEvent(
							this,
							'internal_search_result_display', { 
								search_engine_name : _self.searchengin,
								search_engine_keyword : _self.keywordTms,
						
								search_engine_result_number : _self.nbResultsNatural.toString(),
								search_engine_result_page : currentPage
							}
						);
                    }

                    if (typeof response.Result.Links !== "undefined") {
                        _self.links = response.Result.Links;
                        _self.nbResultTotal = _self.nbResultsNatural + _self.links.length;
                    }
                }
                window.EventBusCMS.dispatchEvent('buildSearch', {isReady : 'search'});

			})
            .fail(function() {
				//_self.callXAPIFail();				
				// tcod 2741 - chargement de la page - fail
				bddfTms.trackEvent(
					this,
					'internal_search_result_display', { 
						search_engine_name : _self.searchengin,
						search_engine_keyword : _self.keywordTms,
						search_engine_result_number : '0',
						search_engine_result_page : ''
					}
				);
			
				window.EventBusCMS.dispatchEvent('buildSearch', {isReady : 'search'});
            });
    }

    callSearchApi() {
        if (this.methodXsearch) 
            this.callXsearchAPI();
        else 
            this.callXrestAPI();	
	}
	// ONLY FOR TEST - SIMULATE callX...
		/*var response = {
			"ProcessingTime": " 9 ms",
			"RowFetchTime": " 2 ms",
			"DocumentCount": 3,
			"TotalCount": 3,
			"PageCount": 1,
			"CurrentPage": 1,
			"DocumentsPerPage": 200,
			"DocumentsThisPage": 3,
			"ProductTitle": "Sinequa Enterprise Search",
			"Result": {
				"queryid": "",
				"resultid": "89286C8351874F1BA7DD47C58B2A29F9",
				"Docs": [
					{	"docid": "\/NGC-Source\/PRI-ANON-Collection\/|http:\/\/192.65.110.83:40700\/articles-actualites\/preparer-retraite-50-60-ans",
						"collection": "\/NGC-Source\/PRI-ANON-Collection\/",
						"company": "SOCIETE GENERALE;Soci\u00e9t\u00e9 G\u00e9n\u00e9rale;411,16,496,16,990,16,3435,16,7115,16,7217,16;18207,20,19352,20,41641,20,54541,20,66733,20,68482,20;CREDIT DU NORD;Cr\u00e9dit du Nord;330,14,877,14;17064,15,39838,15",
						"docrank": 0,
						"docformat": "htm",
						"extracts": "Plus vous ferez {b}t\u00f4t{nb} cette d\u00e9marche et plus il vous sera possible de signaler rapidement aux organismes concern\u00e9s les \u00e9ventuels oublis, pour r\u00e9gularisation.;1878,155;52046,160;Ainsi, plus le demandeur s'y prend {b}t\u00f4t{nb}, moins le rachat de ses trimestres sera \u00e9lev\u00e9.;2463,85;52944,90",
						"fileext": "htm",
						"filename": "preparer-retraite-50-60-ans",
						"flags": "h",
						"fullsummaryhtml": "<b>t&#244;t <\/b>",
						"geo": "AUVERGNE;Auvergne;378,8,941,8;17757,8,40877,8;RHONE-ALPES;Rh\u00f4ne-Alpes;387,11,950,11;17766,12,40886,12;ILE-DE-FRANCE;Ile-de-France;514,13,1008,13;19374,14,41663,14;CORSE;Corse;429,5;18229,5;MONACO;Monaco;979,6;41386,6",
						"globalrelevance": 64,
						"hashtml": true,
						"index": "PRI_ANON_Index",
						"indexationtime": "2023-10-06 00:07:14",
						"internalglobalrelevance": 0.649915,
						"imageurl": "images\/html.gif",
						"languages": "fr",
						"largesummaryhtml": "Plus vous ferez <b>t&#244;t <\/b>cette d&#233;marche et plus il vous sera possible de signaler rapidement aux organismes concern&#233;s les &#233;ventuels oublis, pour r&#233;gularisation.... Ainsi, plus le demandeur s&#39;y prend <b>t&#244;t<\/b>, moins le rachat de ses trimestres sera &#233;lev&#233;.",
						"matchingpartnames": "text",
						"matchlocations": "1894,3,2498,3;52062,4,52981,4",
						"matchlocationsperterm": "tot;1894.3,2498.3;52062.4,52981.4",
						"modified": "2023-10-06 00:07:14",
						"source": "NGC-Source",
						"version": "S0F37SW570I1pi72vRPTQA==",
						"title": "Pr\u00e9parer sa retraite : que faut-il faire de 50 \u00e0 60 ans ? (\u00e2ge, revenus ...",
						"treepath": "\/NGC-Source\/",
						"size": 72951,
						"smallsummaryhtml": "Plus vous ferez <b>t&#244;t <\/b>cette d&#233;marche et plus il vous sera possible ... organismes concern&#233;s les &#233;ventuels oublis, pour r&#233;gularisation.... Ainsi, plus le demandeur s&#39;y prend <b>t&#244;t<\/b>, moins le rachat de ses trimestres sera &#233;lev&#233;.",
						"smallimageurl": "images\/html-small.gif",
						"tinyimageurl": "images\/html-small-2.gif",
						"resultid": "89286C8351874F1BA7DD47C58B2A29F9",
						"resulturl": "\/articles-actualites\/preparer-retraite-50-60-ans",
						"resulttitle": "Pr\u00e9parer sa retraite : que faut-il faire de 50 \u00e0 60 ans ? (\u00e2ge, revenus ...",
						"urlcachehtmltext": "download\/htmltext\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fpreparer-retraite-50-60-ans\/file.htm",
						"urlcachehtml": "download\/html\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fpreparer-retraite-50-60-ans\/file.htm",
						"urldocresult": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"urldocresultontext": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9&on=text",
						"urldocresultleft": "docresultleft?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"urldocresultvert": "docresultvert?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"urldocresulthorz": "docresulthorz?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"term": {
							"term1": "tot;1894.3,2498.3;52062.4,52981.4",
							"termsall": "tot;1894.3,2498.3;52062.4,52981.4"
						}
					},
					{	"docid": "\/NGC-Source\/PRI-ANON-Collection\/|http:\/\/192.65.110.83:40700\/articles-actualites\/guide-quand-comment-constituer-faire-son-epargne",
						"collection": "\/NGC-Source\/PRI-ANON-Collection\/",
						"company": "SOCIETE GENERALE;Soci\u00e9t\u00e9 G\u00e9n\u00e9rale;65,16,417,16,502,16,996,16,2256,16,2328,16,3959,16,5207,16,5913,16,6015,16,6295,16;431,20,18228,20,19373,20,41662,20,52899,20,53109,20,56507,20,58796,20,66199,20,67948,20,72583,36;CREDIT DU NORD;Cr\u00e9dit du Nord;336,14,883,14;17085,15,39859,15",
						"docrank": 1,
						"docformat": "htm",
						"extracts": "plus vous commencez \u00e0 \u00e9pargner {b}t\u00f4t{nb}, moins l'effort d'\u00e9pargne est important.;3521,75;55553,83;C'est pourquoi en ouvrant un contrat le plus {b}t\u00f4t{nb} possible, vous optimisez la fiscalit\u00e9 et confirmez l'int\u00e9r\u00eat de \u00ab prendre date \u00bb, m\u00eame avec un faible versement.;3757,161;55833,182",
						"fileext": "htm",
						"filename": "guide-quand-comment-constituer-faire-son-epargne",
						"flags": "h",
						"fullsummaryhtml": "<b>t&#244;t<\/b>",
						"geo": "AUVERGNE;Auvergne;384,8,947,8;17778,8,40898,8;RHONE-ALPES;Rh\u00f4ne-Alpes;393,11,956,11;17787,12,40907,12;ILE-DE-FRANCE;Ile-de-France;520,13,1014,13;19395,14,41684,14;CORSE;Corse;435,5;18250,5;MONACO;Monaco;985,6;41407,6",
						"globalrelevance": 64,
						"hashtml": true,
						"index": "PRI_ANON_Index",
						"indexationtime": "2023-10-06 00:07:15",
						"internalglobalrelevance": 0.646448,
						"imageurl": "images\/html.gif",
						"languages": "fr",
						"largesummaryhtml": "plus vous commencez &#224; &#233;pargner <b>t&#244;t<\/b>, moins l&#39;effort d&#39;&#233;pargne est important.... C&#39;est pourquoi en ouvrant un contrat le plus <b>t&#244;t <\/b>possible, vous optimisez la fiscalit&#233; et confirmez l&#39;int&#233;r&#234;t de &#171; prendre date &#187;, m&#234;me avec un faible versement.",
						"matchingpartnames": "text",
						"matchlocations": "3552,3,3802,3;55586,4,55880,4",
						"matchlocationsperterm": "tot;3552.3,3802.3;55586.4,55880.4",
						"modified": "2023-10-06 00:07:15",
						"source": "NGC-Source",
						"version": "Ghem5Te123lNmVYCUWA9eQ==",
						"title": "Guide de l'\u00e9pargne : quand et comment constituer son \u00e9pargne ? - Soci\u00e9t\u00e9 G\u00e9n\u00e9rale",
						"treepath": "\/NGC-Source\/",
						"size": 72417,
						"smallsummaryhtml": "plus vous commencez &#224; &#233;pargner <b>t&#244;t<\/b>, moins l&#39;effort d&#39;&#233;pargne est important.... C&#39;est pourquoi en ouvrant un contrat le plus <b>t&#244;t <\/b>possible, vous optimisez la fiscalit&#233; et confirmez ... date &#187;, m&#234;me avec un faible versement.",
						"smallimageurl": "images\/html-small.gif",
						"tinyimageurl": "images\/html-small-2.gif",
						"resultid": "89286C8351874F1BA7DD47C58B2A29F9",
						"resulturl": "\/articles-actualites\/guide-quand-comment-constituer-faire-son-epargne",
						"resulttitle": "Guide de l'\u00e9pargne : quand et comment constituer son \u00e9pargne ? - Soci\u00e9t\u00e9 G\u00e9n\u00e9rale",
						"urlcachehtmltext": "download\/htmltext\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fguide-quand-comment-constituer-faire-son-epargne\/file.htm",
						"urlcachehtml": "download\/html\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fguide-quand-comment-constituer-faire-son-epargne\/file.htm",
						"urldocresult": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"urldocresultontext": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9&on=text",
						"urldocresultleft": "docresultleft?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"urldocresultvert": "docresultvert?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"urldocresulthorz": "docresulthorz?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"term": {
							"term1": "tot;3552.3,3802.3;55586.4,55880.4",
							"termsall": "tot;3552.3,3802.3;55586.4,55880.4"
						}
					},
					{	"docid": "\/NGC-Source\/PRI-ANON-Collection\/|http:\/\/192.65.110.83:40700\/articles-actualites\/quel-est-meilleur-placement-bancaire",
						"collection": "\/NGC-Source\/PRI-ANON-Collection\/",
						"company": "SOCIETE GENERALE;Soci\u00e9t\u00e9 G\u00e9n\u00e9rale;394,16,479,16,973,16,5765,16,5867,16;18162,20,19307,20,41596,20,64108,20,65857,20;CREDIT DU NORD;Cr\u00e9dit du Nord;313,14,860,14;17019,15,39793,15",
						"docrank": 2,
						"docformat": "htm",
						"extracts": "Plus vous \u00e9pargnez {b}t\u00f4t{nb}, plus vous augmentez votre capacit\u00e9 d'emprunt le jour o\u00f9 vous avez besoin de souscrire un pr\u00eat immobilier.;2511,129;52879,136",
						"fileext": "htm",
						"filename": "quel-est-meilleur-placement-bancaire",
						"flags": "h",
						"fullsummaryhtml": "<b>t&#244;t<\/b>",
						"geo": "AUVERGNE;Auvergne;361,8,924,8;17712,8,40832,8;RHONE-ALPES;Rh\u00f4ne-Alpes;370,11,933,11;17721,12,40841,12;ILE-DE-FRANCE;Ile-de-France;497,13,991,13;19329,14,41618,14;CORSE;Corse;412,5;18184,5;MONACO;Monaco;962,6;41341,6",
						"globalrelevance": 61,
						"hashtml": true,
						"index": "PRI_ANON_Index",
						"indexationtime": "2023-10-06 00:07:22",
						"internalglobalrelevance": 0.619396,
						"imageurl": "images\/html.gif",
						"languages": "fr",
						"largesummaryhtml": "Plus vous &#233;pargnez <b>t&#244;t<\/b>, plus vous augmentez votre capacit&#233; d&#39;emprunt le jour o&#249; vous avez besoin de souscrire un pr&#234;t immobilier.",
						"matchingpartnames": "text",
						"matchlocations": "2530,3;52899,4",
						"matchlocationsperterm": "tot;2530.3;52899.4",
						"modified": "2023-10-06 00:07:22",
						"source": "NGC-Source",
						"version": "LkQYszsKIgbbFOlAADJFGQ==",
						"title": "Quel est le meilleur placement bancaire pour son \u00e9pargne ?",
						"treepath": "\/NGC-Source\/",
						"size": 70326,
						"smallsummaryhtml": "Plus vous &#233;pargnez <b>t&#244;t<\/b>, plus vous augmentez votre capacit&#233; d&#39;emprunt le jour o&#249; vous avez besoin de souscrire un pr&#234;t immobilier.",
						"smallimageurl": "images\/html-small.gif",
						"tinyimageurl": "images\/html-small-2.gif",
						"resultid": "89286C8351874F1BA7DD47C58B2A29F9",
						"resulturl": "\/articles-actualites\/quel-est-meilleur-placement-bancaire",
						"resulttitle": "Quel est le meilleur placement bancaire pour son \u00e9pargne ?",
						"urlcachehtmltext": "download\/htmltext\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fquel-est-meilleur-placement-bancaire\/file.htm",
						"urlcachehtml": "download\/html\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fquel-est-meilleur-placement-bancaire\/file.htm",
						"urldocresult": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"urldocresultontext": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9&on=text",
						"urldocresultleft": "docresultleft?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"urldocresultvert": "docresultvert?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"urldocresulthorz": "docresulthorz?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9",
						"term": {
							"term1": "tot;2530.3;52899.4",
							"termsall": "tot;2530.3;52899.4"
						}
					}
				],
				"Boxes": [],
				"Links": []
			},
			"methodresult": "ok"
		};
				
		// Simulate 
		// - done
		this.callXAPIDone(response, "rest");
		// - fail
		//this.callXAPIFail();	       
    }
	
    callSearchApiTest0resultat() {
		
		// TEST 2741 - SIMULATE callX...
		var response = {
			"ProcessingTime": " 4 ms",
			"RowFetchTime": "0 ms",
			"DocumentCount": 0,
			"TotalCount": 0,
			"PageCount": 0,
			"CurrentPage": 0,
			"DocumentsPerPage": 200,
			"DocumentsThisPage": 0,
			"ProductTitle": "Sinequa Enterprise Search",
			"Result": {
				"queryid": "",
				"resultid": "4D1E0558F24A43B7ADE9BDB569B269FB",
				"Docs": [],
				"Boxes": [],
				"Links": []
			},
			"methodresult": "ok"
		};
		
		// Simulate done
		this.callXAPIDone(response, "rest");      
    }
	*/
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/search/sinequa.js